import { useEffect, useState } from 'react';

/**
 * `useDelayedValueUpdate` allows a state variable to be stored and updated after a set period of time, most likely for allowing an animation of a child element to complete before removing the parent.
 *
 * @param {any} value the target value that we want to store, and then update after a certain amount of time.
 * @param {number} delay amount of time in ms that is takes for the valuu to update after this call
 */

export default function useDelayedValueUpdate(value, delay) {
  const [delayedValue, setDelayedValue] = useState(value);

  useEffect(() => {
    let timeoutId;
    if (value) {
      setDelayedValue(value);
    } else if (delayedValue && !value) {
      timeoutId = setTimeout(() => {
        setDelayedValue(false);
      }, delay);
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [value]);
  return delayedValue;
}
